import React from "react";
import StyledIcon from "@litonarefin/components/StyledIcon";
import { getIcon } from "@litonarefin/utils/icons";
import Link from "next/link";

function FeatureList({
    label,
    icon,
    rightLabel = "",
    rightIcon = "",
    rightColor = "#475467",
    link = false,
}) {
    return (
        <div className="jlt-flex jlt-items-center jlt-justify-between jlt-py-2">
            <p className="jlt-flex jlt-items-center jlt-gap-2 jlt-text-[#98A2B3]">
                <StyledIcon
                    color="#98A2B3"
                    type="stroke"
                    styles={{ width: "24px", height: "24px" }}>
                    {getIcon(icon)}
                </StyledIcon>
                <span>{label}</span>
            </p>
            {!!link ? (
                rightLabel ? (
                    <Link href={`${link}`} style={{ color: rightColor }}>
                        {rightLabel}
                    </Link>
                ) : (
                    <StyledIcon
                        color="#667085"
                        type="stroke"
                        styles={{ width: "24px", height: "24px" }}>
                        {getIcon(rightIcon)}
                    </StyledIcon>
                )
            ) : rightLabel ? (
                <span style={{ color: rightColor }}>{rightLabel}</span>
            ) : (
                <StyledIcon
                    color="#667085"
                    type="stroke"
                    styles={{ width: "24px", height: "24px" }}>
                    {getIcon(rightIcon)}
                </StyledIcon>
            )}
        </div>
    );
}

export default FeatureList;
